import { Controller } from "@hotwired/stimulus"

/**
 * New Neighbor Form Controller
 *
 * Prevents double-submission and requires a first name on the
 * create-a-neighbor form in the attendee picker. The form creates a full
 * Neighbor record and checks them in atomically.
 *
 * Targets:
 *   - form: the <form> element
 *   - firstName: the required first-name input
 *   - submitButton: the submit button (disabled during submission)
 */
export default class extends Controller<HTMLElement> {
  static targets = ["form", "firstName", "submitButton"]

  declare readonly formTarget: HTMLFormElement
  declare readonly firstNameTarget: HTMLInputElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly hasSubmitButtonTarget: boolean

  private submitting = false

  submit(event: Event) {
    const name = this.firstNameTarget.value.trim()

    if (name.length === 0) {
      event.preventDefault()
      this.firstNameTarget.focus()
      this.firstNameTarget.classList.add("input-error")
      return
    }

    if (this.submitting) {
      event.preventDefault()
      return
    }

    this.submitting = true
    this.firstNameTarget.classList.remove("input-error")

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("loading")
    }
  }

  // Re-enable the form if the server returns a validation error (422).
  // Turbo re-renders the frame, which re-connects this controller,
  // resetting `submitting` to false automatically.
  disconnect() {
    this.submitting = false
  }
}
